import {createReducer, on} from '@ngrx/store';
import {VersandstatusHistoryDialogState} from '../states/versandstatus-history-dialog.state';
import {VersandstatusHistoryDialogActions} from '../actions/versandstatus-history-dialog.actions';


export const initialVersandstatusHistoryDialogState: VersandstatusHistoryDialogState = {
  isOpen: false,
};

export const versandstatusHistoryDialogReducer = createReducer(
  initialVersandstatusHistoryDialogState,

  on(
    VersandstatusHistoryDialogActions.open,
    (state, {betriebId, belegId, belegnummer, belegart}) => ({
      ...state,
      isOpen: true,
      betriebId,
      belegId,
      belegnummer,
      belegart,
    }),
  ),

  on(
    VersandstatusHistoryDialogActions.close,
    () => ({...initialVersandstatusHistoryDialogState}),
  ),
);
